// PanelComment Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Avatar from '../../common/avatar/avatar.jsx'
import Input from '../../common/input/input.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PanelComment extends Component {
  constructor (props) {
    super(props)

    this.state = {
      comment: '',
      isFocus: false
    }
  }

  static get propTypes () {
    return {
      comments: PropTypes.array,
      onCreate: PropTypes.func,
      user: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      comments: [],
      onCreate: null,
      user: null
    }
  }

  _onFoucsField () {
    this.setState({ isFocus: true })
  }

  _onBlurField () {
    this.setState({ isFocus: false })
  }

  render () {
    const { comments, user } = this.props
    const { comment, isFocus } = this.state

    return (
      <div className='panel-comment'>
        <div className='commentlist'>
          <div className='item'>
            {!comments.length && (
              <p className='nocomments'><IntlMessage ident='plannerv2.task.noComments' /></p>
            )}
            {comments.map((comment, idx) => (
              <div key={idx} className='userinfo'>
                <div className='imagecol'>
                  <Avatar
                    imageUrl={comment.user ? comment.user.imageUrl : ''}
                    title=''
                  />
                </div>
                <div className='colinfo'>
                  <div className='displayname'>
                    {comment.user ? comment.user.displayName : ''} <span className='dateinfo'>- {DateUtil.getDisplayPickerDate(comment.createdOn)} {DateUtil.getDisplayTime(comment.createdOn)}</span>
                  </div>
                  <div className='content'>{comment.content}</div>
                </div>
              </div>
            ))}
          </div>
          <div className='editcomment'>
            <div className='commentinfo'>
              <div className='imagecol'>
                <Avatar imageUrl={user.imageUrl} title={user.displayName} />
              </div>
              <div className='inputfield'>
                <Input
                  name='content'
                  type='text'
                  value={comment}
                  maxLength={512}
                  onChange={this._onChangeComment} // eslint-disable-line react/jsx-handler-names
                  onKeyDown={this._onKeydownComment.bind(this)}
                  className={isFocus ? 'editable' : ''}
                  onFocus={this._onFoucsField.bind(this)}
                  onBlur={this._onBlurField.bind(this)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onChangeComment = comment => {
    this.setState({ comment })
  }

  _onKeydownComment = ev => {
    if (ev.keyCode === 13) {
      const commentData = {
        content: this.state.comment,
        createdOn: new Date()
      }

      if (this.props.onCreate) {
        this.props.onCreate(commentData)
      }

      this.setState({ comment: '' })
    }
  }
}

export default PanelComment
